import ApiService from '../../../../shared/services/api-service';
import commonActionCreators from '../../../../shared/store/common/action-creators';
import taskGroupsActions from '../../task-groups/action-creators';
import tasksActions from '../../tasks/action-creators/index';
import oitsCommitTypes from '../commit-types';

const oitTasksActions = {
  fetchOitTaskResponses(oitGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchOitTaskResponses'));
      const data = await ApiService.get(`/api/v1/oits/${oitGuid}/task-responses`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchOitTaskResponses'));
      if (data) {
        dispatch(this.fetchOitTaskResponsesSuccess(data));
      }
      return Promise.resolve();
    };
  },
  fetchOitTaskResponsesSuccess(oitTaskResponse) {
    return (dispatch) => {
      dispatch(this.pushTaskResponses(oitTaskResponse.data));
    };
  },
  loadOitTasksIndex(oitGuid) {
    return async (dispatch) => {
      dispatch(tasksActions.fetchTasks());
      dispatch(taskGroupsActions.fetchTaskGroups());
      dispatch(this.fetchOitTaskResponses(oitGuid));
    };
  },
  pushTaskResponses(taskResponses) {
    return {
      taskResponses,
      type: oitsCommitTypes.PUSH_OIT_TASK_RESPONSES,
    };
  },
};

export default oitTasksActions;
